import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, message } from 'antd';
import { verifyChangeEmailLink } from '../../../reducer/userReducer';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import laundroLogo from '../../../images/logo/laundrologo.png';
import cleanproLogo from '../../../images/logo/cleanprologo.png';
import octopusLogo from '../../../images/logo/octopuslogo.png';
import washstudioLogo from '../../../images/washstudio/washstudioLogo.png';
import cuciLogo from '../../../images/cuciExpress/cuci-whiteLogo.png';
import aerosparkleLogo from '../../../images/logo/aerosparklelogo.png';
import bubblepulseLogo from '../../../images/logo/bubblepulseLogo.png';
import jomcucilogo from '../../../images/logo/jomcucilogo.png';

const VerifyChangeEmail = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const { theme } = useSelector((state) => state.theme);
    const { t } = useTranslation();
    const token = searchParams.get('token');
    const { verifyChangeEmailStatus, changeEmailerror } = useSelector((state) => state.user);

    const [logo, setLogo] = useState(null);
    const [slogan, setSlogan] = useState('');
    const [text, setText] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userType, setUserType] = useState('');

    useEffect(() => {
        if (theme === 'laundro') {
            setSlogan('Digitize Your Laundromat');
            setText('Manage your laundry at your fingertips.');
            setLogo(laundroLogo);
        } else if (theme === 'cleanpro') {
            setSlogan('Cleanpro Laundry Management System');
            setText('Integrated Self Service Laundry Management');
            setLogo(cleanproLogo);
        } else if (theme === 'octopus') {
            setSlogan('Octopus Laundry Management System');
            setText('Your Success is our success');
            setLogo(octopusLogo);
        } else if (theme === 'washstudio') {
            setSlogan('Evolve the Future');
            setText('Better Insight with Smarter Machines');
            setLogo(washstudioLogo);
        } else if (theme === 'cuci') {
            setSlogan('Easy & Fast Laundromate');
            setText('Smart Laundry Management System.');
            setLogo(cuciLogo);
        } else if (theme === 'aerosparkle') {
            setSlogan('Sparkling clean laundry');
            setText('Sparkling clean laundry');
            setLogo(aerosparkleLogo);
        } else if (theme === 'bubblespulse') {
            setSlogan('The Urban Laundry Experience');
            setText('The Urban Laundry Experience');
            setLogo(bubblepulseLogo);
        } else if (theme === 'jomcuci') {
            setSlogan('Fresh & Clean Laundry');
            setText('Quick and Convenient Laundry Service');
            setLogo(jomcucilogo);
        }
    }, [theme]);

    useEffect(() => {
        if (verifyChangeEmailStatus?.data === "success") {
            setUserType(verifyChangeEmailStatus?.role);
            setIsModalOpen(true);
        } else if (changeEmailerror) {
            message.error(changeEmailerror?.en || t('Verification failed'));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [verifyChangeEmailStatus, changeEmailerror]);

      const onFinish = (values) => {
        dispatch(
            verifyChangeEmailLink({
                token,
                newEmail: values.newEmail,
            })
        );
    };

    return (
        <div>
            <Modal open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: '6rem' }} />
                    <h3>{t('Email Changed!')}</h3>
                    <Link to={`/${userType}_login`}>
                        <Button type='primary'>{t('Login Account')}</Button>
                    </Link>
                </div>
            </Modal>

            <div className='login-main-container d-sm-flex justify-content-evenly'>
                <div className='mx-3 pt-3'>
                    <div className={theme === 'washstudio' ? 'text-center' : 'text-white heading-text'}>
                        <img className='laundro-login-logo pb-4' src={logo} alt='brand logo' />
                        <h2>{slogan}</h2>
                        <div className='py-4 fw-bold'>{text}</div>
                    </div>
                    <div className='pt-4 desktop-terms' style={{ textAlign: theme === 'washstudio' ? 'center' : 'start' }}>
                        <a className='login-link' href='/terms&conditions'>{t('Terms & Conditions')}</a>
                        <a className='login-link' href='/privacypolicy'>{t('Privacy & Policy')}</a>
                    </div>
                </div>

                <div className='card mx-3 py-5 px-4' style={{ maxWidth: '500px', minWidth: '30vw' }}>
                    <div className='mb-2'>
                        <h2>{t('Verify Change Email')}</h2>
                    </div>
                    <Form layout='vertical' onFinish={onFinish}>
                        <Form.Item
                            name='newEmail'
                            label={t('New Email')}
                            rules={[{ required: true, type: 'email', message: t('Required') }]}
                        >
                            <Input placeholder={t('Enter new email')} />
                        </Form.Item>
                        <Button type='primary' htmlType='submit' block>{t('Submit')}</Button>
                    </Form>
                </div>

                <div className='mobile-terms text-center pb-3'>
                    <a className='login-link' href='/terms&conditions'>{t('Terms & Conditions')}</a>
                    <a className='login-link' href='/privacypolicy'>{t('Privacy & Policy')}</a>
                </div>
            </div>
        </div>
    );
};

export default VerifyChangeEmail;